import { ADDINVOICE, ADDINVOICE_FAILED, ADDINVOICE_SUCCESS, DELETEINVOICE, DELETEINVOICE_FAILED, DELETEINVOICE_SUCCESS, INVOICEID, INVOICEID_FAILED, INVOICEID_SUCCESS, INVOICES, INVOICESLIST, INVOICESLIST_FAILED, INVOICESLIST_SUCCESS, INVOICES_FAILED, INVOICES_SUCCESS, TAXLIST, TAXLIST_FAILED, TAXLIST_SUCCESS, UPDATEINVOICE, UPDATEINVOICE_FAILED, UPDATEINVOICE_SUCCESS, UPDATESTATUS, UPDATESTATUS_FAILED, UPDATESTATUS_SUCCESS, VIEWINVOICE, VIEWINVOICE_FAILED, VIEWINVOICE_SUCCESS, CURRENCY_LIST, CURRENCY_LIST_SUCCESS, CURRENCY_LIST_FAILED, SYSTEM_SETTINGS, SYSTEM_SETTINGS_SUCCESS, SYSTEM_SETTINGS_FAILED, INVOICE_DEFAULT_TERMS, INVOICE_DEFAULT_TERMS_SUCCESS, INVOICE_DEFAULT_TERMS_FAILED, ADD_PURCHASEINVOICETOCSV, ADD_PURCHASEINVOICETOCSV_SUCCESS, ADD_PURCHASEINVOICETOCSV_FAILURE, PURCHASE_INVOICES_FAILURE, PURCHASE_INVOICES_SUCCESS, PURCHASE_INVOICES, DELETEPURCHASEINVOICE, DELETEPURCHASEINVOICE_SUCCESS, DELETEPURCHASEINVOICE_FAILED, } from "./actionTypes";

let initialState = {
    invoices: [],
    invoiceDetails: {},
    invoiceslist: [],
    taxList: [],
    invoiceId: 0,
    addedInvoice: '',
    updatedInvoice: '',
    deletedInvoices: [],
    loading: false,
    success: false,
    error: '',
    currencylist: [],
    systemsettings: [],
    invoiceterms: [],
    addPurchaseInvoice: "",
    purchaseInvoice: [],
    deletedPurchaseInvoices: []
}

export const invoicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case INVOICES: return {
            ...state,
            invoices: [],
            loading: true,
            success: false,
            error: ''
        }
        case INVOICES_SUCCESS: return {
            ...state,
            invoices: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case INVOICES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case INVOICESLIST: return {
            ...state,
            invoiceslist: [],
            loading: true,
            success: false,
            error: ''
        }
        case INVOICESLIST_SUCCESS: return {
            ...state,
            invoiceslist: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case INVOICESLIST_FAILED: return {
            ...state,
            invoiceslist: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case INVOICEID: return {
            ...state,
            invoiceId: 0,
            loading: true,
            success: false,
            error: ''
        }
        case INVOICEID_SUCCESS: return {
            ...state,
            invoiceId: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case INVOICEID_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case TAXLIST: return {
            ...state,
            taxList: [],
            loading: true,
            success: false,
            error: ''
        }
        case TAXLIST_SUCCESS: return {
            ...state,
            taxList: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case TAXLIST_FAILED: return {
            ...state,
            taxList: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ADDINVOICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADDINVOICE_SUCCESS: return {
            ...state,
            addedInvoice: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADDINVOICE_FAILED: return {
            ...state,
            addedInvoice: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATEINVOICE: return {
            ...state,
            loading: true,
            sucess: false,
            error: ''
        }
        case UPDATEINVOICE_SUCCESS: return {
            ...state,
            updatedInvoice: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATEINVOICE_FAILED: return {
            ...state,
            updatedInvoice: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETEINVOICE: return {
            ...state,
            loading: true,
            sucess: false,
            error: ''
        }
        case DELETEINVOICE_SUCCESS: return {
            ...state,
            deletedInvoices: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case DELETEINVOICE_FAILED: return {
            ...state,
            deletedInvoices: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case VIEWINVOICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case VIEWINVOICE_SUCCESS: return {
            ...state,
            loading: false,
            invoiceDetails: action.payload,
            success: true,
            error: ''
        }
        case VIEWINVOICE_FAILED: return {
            ...state,
            loading: false,
            invoiceDetails: {},
            success: false,
            error: action.payload
        }
        case UPDATESTATUS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATESTATUS_SUCCESS: return {
            ...state,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATESTATUS_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case CURRENCY_LIST: return {
            ...state,
            currencylist: [],
            loading: true,
            success: false,
            error: ''
        }
        case CURRENCY_LIST_SUCCESS: return {
            ...state,
            currencylist: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case CURRENCY_LIST_FAILED: return {
            ...state,
            currencylist: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case SYSTEM_SETTINGS: return {
            ...state,
            systemsettings: [],
            loading: true,
            success: false,
            error: ''
        }
        case SYSTEM_SETTINGS_SUCCESS: return {
            ...state,
            systemsettings: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SYSTEM_SETTINGS_FAILED: return {
            ...state,
            systemsettings: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case INVOICE_DEFAULT_TERMS: return {
            ...state,
            invoiceterms: [],
            loading: true,
            success: false,
            error: ''
        }
        case INVOICE_DEFAULT_TERMS_SUCCESS: return {
            ...state,
            invoiceterms: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case INVOICE_DEFAULT_TERMS_FAILED: return {
            ...state,
            invoiceterms: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_PURCHASEINVOICETOCSV: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_PURCHASEINVOICETOCSV_SUCCESS: return {
            ...state,
            addPurchaseInvoice: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_PURCHASEINVOICETOCSV_FAILURE: return {
            ...state,
            addPurchaseInvoice: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case PURCHASE_INVOICES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case PURCHASE_INVOICES_SUCCESS: return {
            ...state,
            purchaseInvoice: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case PURCHASE_INVOICES_FAILURE: return {
            ...state,
            purchaseInvoice: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETEPURCHASEINVOICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case DELETEPURCHASEINVOICE_SUCCESS: return {
            ...state,
            deletedPurchaseInvoices: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case DELETEPURCHASEINVOICE_FAILED: return {
            ...state,
            deletedPurchaseInvoices: [],
            loading: false,
            success: false,
            error: action.payload
        }
        default:
            return state
    }
}